module.exports = __webpack_public_path__ + "static/media/img-destaque-home.ad20d7d8.jpg";